import { ServerUri } from "./Tools";

export const RequestAsync = async (uri, params, requestManager) => {
    const urlFinal = `${ServerUri()}${uri}`;
    let token = await localStorage.getItem('bitso-reader-troken')
    token = token ? token : ""
    const body = JSON.stringify(params)
    const response = await fetch(urlFinal, {
        method: 'POST',
        headers: {
            'Accept': '*/*',
            'Accept-Encoding': 'gzip, deflate, br',
            'Content-Type': 'application/json',
            'Connection': 'keep-alive',
            'bitso-reader-troken': token
        },
        body: body
    });
    const rText = await response.json();
    return rText;
}

export const FileUploadAsync = async (file, uri = "upload", params = null) => {
    // debugger
    if (!params) {
        params = {
            file: file.name,
            offset: file.size,
            last: true,
            first: true,
            docType: "document",
        }
    }
    const sp = new URLSearchParams(params)
    //const urlFinal = `${ServerUri()}${uri}?${sp.toString()}`;
    const urlFinal = `${ServerUri()}${uri}`;
    let token = await localStorage.getItem('pre-troken')
    token = token ? token : ""

    let _data = new FormData();
    _data.append("upload", file);
    let _result = await fetch(urlFinal, {
        method: 'POST',
        headers: {
            'Accept': '*/*',
            // 'Content-Type': 'multipart/form-data',
        },
        body: _data
    });
    const rText = await _result.json();
    return rText;
}